import React from 'react';

import MessageDialog from 'components/Shared/MessageDialog';

import { useQuery } from "react-query";
import { fetchParametre } from 'utils/queries';

import { ParametreCodes } from 'constants.js';

const SavHorsGarantieMajorationDialog = ({ onNOK }) => {

    const savMajorationMontantQuery = useQuery([ParametreCodes.SAVMajorationMontant], () => fetchParametre({ parametre: ParametreCodes.SAVMajorationMontant }));
    const savMajorationCodeArticleQuery = useQuery([ParametreCodes.SAVMajorationCodeArticle], () => fetchParametre({ parametre: ParametreCodes.SAVMajorationCodeArticle }));

    let isLoading = savMajorationMontantQuery.isLoading || savMajorationCodeArticleQuery.isLoading;
    let error = savMajorationMontantQuery.error || savMajorationCodeArticleQuery.error;

    if (isLoading || error) {
        return null;
    }

    let contenu = `Une majoration de ${savMajorationMontantQuery.data} doit être appliquée au client.\nMerci d'ajouter le code article ${savMajorationCodeArticleQuery.data} sur la commande client.`;

    return (
        <>
            <MessageDialog
                titre="Avertissement"
                contenu={contenu}
                ouvert={true}
                init={true}

                texteNOK="Annuler"
                texteOK="Poursuivre"

                onNOK={onNOK}
            />
        </>
    );
}

export default SavHorsGarantieMajorationDialog;